var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9593 2.8001C16.7999 1.92041 16.0406 1.27979 15.1593 1.07979C13.8406 0.800098 11.4 0.600098 8.75933 0.600098C6.12026 0.600098 3.64058 0.800098 2.32026 1.07979C1.44058 1.27979 0.679639 1.87978 0.520264 2.8001C0.359326 3.8001 0.199951 5.2001 0.199951 7.0001C0.199951 8.8001 0.359326 10.2001 0.559326 11.2001C0.720264 12.0798 1.47964 12.7204 2.35933 12.9204C3.75933 13.2001 6.15933 13.4001 8.79995 13.4001C11.4406 13.4001 13.8406 13.2001 15.2406 12.9204C16.1203 12.7204 16.8796 12.1204 17.0406 11.2001C17.1999 10.2001 17.4 8.75947 17.4406 7.0001C17.3593 5.2001 17.1593 3.8001 16.9593 2.8001ZM6.59995 9.8001V4.2001L11.4796 7.0001L6.59995 9.8001Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5e519b0e.svg";
export { ForwardRef as ReactComponent };